import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getBlogCategory,
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';

const BlogCategory = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      BlogCategoryList,
      blogCategoryCount,
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [type, setType] = useState("");
  const [paginate, setPaginate] = useState(10);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getBlogCategory(auth?.token, paginate, page, search, sort, type))
  }, [auth, paginate, page, search, sort, type]);

  const csvHead = [['type', 'name', 'parent', 'thumbnail']]
  const csvData = BlogCategoryList.map((cv) => [
    cv?.type == 1 ? "blog" : cv?.type == 2 ? "event" : "resource",
    cv?.category_name,
    cv?.parent,
    cv?.thumbnail,
  ])
  const exportData = csvHead.concat(csvData);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Blog Category")) {
      axios
        .delete(`/api/admin/v1/blog-category-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getBlogCategory(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Blog Category List</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BLOGCATEGORIES" && item?.permission?.permission === "create") && (
              <Link to="/add-blog-category">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Blog Category
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>
        <div className="row">
          <div className="col-md-2 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2">
            <Input type="select" size={"sm"} value={type} onChange={(({ target }) => setType(target.value))} >
              <option value="">Select Type</option>
              <option value="1">Blog</option>
              <option value="2">Event</option>
              <option value="3">Resource</option>
            </Input>
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "BLOGCATEGORIES" &&
              item?.permission?.permission === "export"
          ) ? "offset-md-5" : "offset-md-6"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BLOGCATEGORIES" && item?.permission?.permission === "export") && (
            <div className="col-md-1 mb-2">
              <CSVLink
                filename={
                  "blog-category-lists.csv"
                }
                className="text-black ms-1"
                title="Export To CSV"
                data={exportData}
              >
                <BiSolidFileExport size={25} />
              </CSVLink>
            </div>
          )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Category Name</th>
                  <th>Type</th>
                  <th>Parent</th>
                  <th>Image</th>
                  {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BLOGCATEGORIES" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {BlogCategoryList.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {BlogCategoryList?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.category_name}</td>
                        <td>{(item?.type == 1) ? "Blog" : (item?.type == 2) ? "Event" : (item?.type == 3) ? "Resource" : ""}</td>
                        <td>{item?.ParentName?.category_name}</td>
                        <td>
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                            height={45}
                            width={45}
                          />
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BLOGCATEGORIES" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/edit-blog-category/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BLOGCATEGORIES" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {blogCategoryCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, blogCategoryCount)} of {blogCategoryCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(blogCategoryCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCategory;
